import { axiosInstance } from ".."

const markDeliverable = async (projectID,data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`/internal/pm/makeDeliverable/${projectID}`,data,).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default markDeliverable;